module.exports = __webpack_public_path__ + "static/grafika1-d1706679d989b921eb5e265bd6927520.png";